/* eslint-disable no-restricted-globals */

import moment from 'moment'
import { LKDate, monthsArray, weeksArray } from 'loankeeper-common/helpers/Date'

import { translate } from 'loankeeper-common/helpers'

export const trans = (text) => translate(`frm_date_picker-${text}`)

export const getMonths = () => monthsArray.map((month) => month.toLowerCase()).map((month) => trans(month))

export const getShortWeeks = () => weeksArray.map((week) => week.toLowerCase()).map((week) => trans(`${week}_short`))

export const getStandartDate = (date) => {
  if (date) {
    if (LKDate.from(date).isValid()) {
      return LKDate.from(date).toDate()
    }
  }

  return undefined
}

export const formatDate = (date) => {
  const dateInstance = LKDate.from(date)

  return date && dateInstance.toString() !== '-' ? dateInstance.toString() : null
}

export const addMonthToDate = (date) => {
  const resultDate = getStandartDate(date)

  return resultDate ? moment(resultDate).add(1, 'month').toDate() : moment(new Date()).add(1, 'month').toDate()
}

export const handleKeyDown = (e) => {
  const allowedKeys = ['ArrowLeft', 'ArrowRight', '.', 'Backspace', 'Tab']
  const { value } = e.target
  const { key } = e

  if (e.key === '.' && value[value.length - 1] === '.') {
    e.preventDefault()
  }

  // Ctrl + C
  if (e.ctrlKey && e.keyCode) {
    return
  }

  if (isNaN(key) && allowedKeys.indexOf(key) === -1) {
    e.preventDefault()
  }

  if (
    value &&
    value.length > 9 &&
    e.target.selectionStart === e.target.selectionEnd &&
    allowedKeys.indexOf(e.key) === -1
  ) {
    e.preventDefault()
  }
}

export const datepickerNormalizer = (value, prevValue) => {
  if (value) {
    // we are deleting stuff
    if ((prevValue || '').length > value.length) {
      if (value[value.length - 1] === '.') {
        return value.substr(0, value.length - 1)
      }
    }

    if ((prevValue || '').length < value.length) {
      // handle case when user enters something like this: 1. ...
      if (value.length === 2 && value[1] !== '.') {
        return `${value}.`
      }

      if (value.length === 3 && value[2] !== '.' && (value.match(/\./g) || []).length < 1) {
        return `${prevValue}.${value[value.length - 1]}`
      }

      // handle case when user enters something like this: 1.1. ...
      if (value.length === 5 && (value.match(/\./g) || []).length === 1) {
        return `${value}.`
      }

      if (value.length === 6 && value[5] !== '.' && (value.match(/\./g) || []).length === 1) {
        return `${prevValue}.${value[value.length - 1]}`
      }
    }

    return value
  }

  return ''
}
